const base64Decrypt = (text: string) => {
	return atob(text);
};

export default base64Decrypt;
